<template>
    <div class="modal fade" id="residences-modal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                <div class="modal-body py-5 px-4 text-right">
                    <div class="form-group mt-2">
                        <label>{{ tra.accommodation_age_question }}</label>
                        <select 
                            @change="handleAgeChange"
                            :value="selectResidenceAge"
                            class="form-control rounded-10 border select-residence-age py-0"
                        >
                            <option value="">{{ tra.please_select }}</option>
                            <option value="under_16">{{ tra.under_16_age }}</option>
                            <option value="16">{{ tra.age_16_option }}</option>
                            <option value="17">{{ tra.age_17_option }}</option>
                            <option value="18">{{ tra.over_18 }}</option>
                        </select>
                    </div>
                    <hr>
                    
                    <h5>
                        <input 
                            style="height: 20px; width: 20px;" 
                            type="radio" 
                            :value="residenceId"
                            @change="$emit('update-residence-id', 'no-residence-needed')"
                            value="no-residence-needed"
                        >
                        {{ tra.no_need_accommodation }}
                    </h5>
                    <hr class="my-2">
                    
                    <div v-for="residence in sortedResidences" :key="residence.id">
                        <div class="text-dark d-flex mb-4">
                            <input 
                                @change="handleResidenceChange"
                                style="height: 20px; width: 20px;margin-top: 5px;" 
                                type="radio"
                                :value="residenceId"
                                :checked="residenceId == residence.id"
                                :data-residence-id="residence.id"
                            >
                            <div class="mr-3">
                                {{ residence.description || '' }}
                                <div>
                                    <div v-if="residence.price.residence_discount_obj.total_discounts" class="d-flex align-items-end">
                                        <del class="text-danger">{{ residence.price.residence_price_formated }}</del>
                                        <p class="text-main-color mt-1 d-block">
                                            <strong>{{ residence.price.residence_discounted_price_formated }}</strong> / {{ weeksOutput(1) }}
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p class="text-main-color mt-1 d-block">
                                            <strong>{{ residence.price.residence_price_formated }}</strong> / {{ weeksOutput(1) }}
                                        </p>
                                    </div>
                                </div>
                                <strong
                                    v-if="residence.available_date_end != null && residence.available_date_from != null"
                                    class="text-danger mt-1 d-block"
                                > 
                                    ( {{ tra.available_only_from }}
                                    {{ formatDate(residence.available_date_from) }} {{ tra.to }}
                                    {{ formatDate(residence.available_date_end) }} ) 
                                </strong>
                            </div>
                        </div>

                        <ResidenceDetails :residence="residence" :tra="tra" />
                        <hr class="my-2">
                    </div>

                    <CustomResidenceForm
                        v-if="residenceId == 'custom_residence'"
                        :custom-residence="customResidence"
                        :tra="tra"
                        @update-custom-residence="$emit('update-custom-residence', $event)"
                        @choose-custom-residence="$emit('choose-custom-residence')"
                    />

                    <button 
                        v-if="isAdmin == '1'" 
                        @click="$emit('update-residence-id', 'custom_residence')" 
                        type="button"
                        class="btn rounded-10 bg-secondary-color w-100 text-center mb-3 text-white"
                    >
                        {{ tra.add_custom_accommodation }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResidenceDetails from './ResidenceDetails.vue';
import CustomResidenceForm from './CustomResidenceForm.vue';

export default {
    name: 'ResidenceModal',
    components: {
        ResidenceDetails,
        CustomResidenceForm,
    },
    props: {
        residencesObj: [Array, Object],
        residenceId: [String, Number],
        selectResidenceAge: String,
        customResidence: Object,
        weeksCount: Number,
        isAdmin: [String, Number],
        tra: Object,
    },
    emits: [
        'update-residence-id',
        'update-select-residence-age',
        'update-custom-residence',
        'choose-custom-residence',
        'residence-change',
    ],
    computed: {
        sortedResidences() {
            if (!this.residencesObj || !Array.isArray(this.residencesObj)) {
                return [];
            }

            let filteredResidences = this.residencesObj;

            if (this.residencesObj.length > 0) {
                const selectedResidence = this.residencesObj.find(residence => residence.id == this.residenceId);
                if (selectedResidence) {
                    const minAge = selectedResidence.min_age;
                    if (minAge < 16) {
                        this.$emit('update-select-residence-age', 'under_16');
                    } else {
                        this.$emit('update-select-residence-age', minAge);
                    }
                }
            }

            if (filteredResidences.length > 0) {
                if (this.selectResidenceAge == 'under_16') {
                    filteredResidences = filteredResidences.filter(residence => residence.min_age < 16);
                }
                if (this.selectResidenceAge == 16) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 16 ||
                        (residence.min_age < 16 && (residence.max_age == null || residence.max_age >= 16))
                    );
                }
                if (this.selectResidenceAge == 17) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 17 ||
                        (residence.min_age < 17 && (residence.max_age == null || residence.max_age >= 17))
                    );
                }
                if (this.selectResidenceAge == 18) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age >= 18 || (residence.max_age == null || residence.max_age >= 18)
                    );
                }
                if (this.selectResidenceAge == '') {
                    filteredResidences = filteredResidences.filter(residence => false);
                }
            }

            const sortingOrder = [
                'family_accommodation',
                'student_housing',
                'private_studio'
            ];

            if (filteredResidences.length > 0) {
                return filteredResidences.sort((a, b) => {
                    const indexA = sortingOrder.indexOf(a.residence_type);
                    const indexB = sortingOrder.indexOf(b.residence_type);
                    return indexA - indexB;
                });
            } else {
                return filteredResidences;
            }
        }
    },
    methods: {
        handleAgeChange(event) {
            this.$emit('update-select-residence-age', event.target.value);
            this.$emit('update-residence-id', 0);
        },
        
        handleResidenceChange(event) {
            const residenceId = event.target.dataset.residenceId;
            this.$emit('update-residence-id', residenceId);
            this.$emit('residence-change');
        },
        
        weeksOutput(weeks) {
            let msg = '';
            if (weeks == 1) { 
                msg = this.tra.weeks_singular || 'اسبوع'; 
            }
            else if (weeks == 2) { 
                msg = this.tra.two_weeks_option || 'اسبوعان'; 
            }
            else if (weeks > 2 && weeks < 11) { 
                msg = weeks + ' ' + (this.tra.weeks || 'اسابيع'); 
            }
            else { 
                msg = weeks + ' ' + (this.tra.weeks_singular || 'اسبوع'); 
            }
            return msg;
        },
        
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }
};
</script>